/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import { useUrlFromHandle } from '../../contexts/RoutesContext';
import { Awards, Sections } from '../blocks';
import Blocks from '../blocks/Blocks';
import RoundedButton from '../buttons/Rounded';
import Header from '../headers/Header';
import CircledPlus from '../icons/CircledPlus';
import Export from '../icons/Export';
import FilmCarousel from '../lists/FilmCarousel';

import styles from '../../../styles/pages/edition.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const EditionPage = ({ page, className }) => {
    const handle = useUrlFromHandle();
    const { title = null, edition = null, blocks = null } = page || {};
    const {
        id = null,
        awards = null,
        sectionGroups = null,
        awardsPage = null,
        magazine = null,
        upcoming = false,
        ended = false,
    } = edition || {};

    const { url: awardsUrl = null } = awardsPage || {};
    const { url: magazineUrl = null } = magazine || {};

    const location = useLocation();
    useScrollToTop(location);

    const editionsUrl = handle('editions');

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.header}>
                {title !== null && (
                    <Header page={page} type="edition">
                        {magazineUrl !== null ? (
                            <div className={styles.buttons}>
                                <RoundedButton
                                    icon={<Export />}
                                    iconPosition="left"
                                    href={magazineUrl}
                                    external
                                >
                                    <FormattedMessage
                                        defaultMessage="Download the booklet"
                                        description="Link label"
                                    />
                                </RoundedButton>
                            </div>
                        ) : null}
                    </Header>
                )}
            </div>
            <div className={styles.defaultBlocks}>
                {ended && awards !== null && awards.length > 0 ? (
                    <div className={styles.section}>
                        <Awards
                            title={
                                <FormattedMessage
                                    defaultMessage="Awards"
                                    description="Heading title"
                                />
                            }
                            edition={edition}
                            url={awardsUrl}
                            awards={awards}
                            isContainer={false}
                        />
                    </div>
                ) : null}
                {!upcoming && id !== null ? (
                    <div className={styles.section}>
                        <FilmCarousel
                            title={
                                <FormattedMessage
                                    defaultMessage="Featured films"
                                    description="Carousel heading"
                                />
                            }
                            query={{ edition: id, featured: true, shuffle: true }}
                        />
                    </div>
                ) : null}
                {!upcoming && sectionGroups !== null && sectionGroups.length > 0
                    ? sectionGroups.map(
                          ({ title: sectionGroupTitle = null, sections = null }, i) => (
                              // eslint-disable-next-line react/jsx-indent
                              <div
                                  className={styles.section}
                                  key={`section-${sectionGroupTitle}-${i + 1}`}
                              >
                                  <Sections
                                      title={
                                          sectionGroupTitle !== null ? (
                                              sectionGroupTitle
                                          ) : (
                                              <FormattedMessage
                                                  defaultMessage="Sections"
                                                  description="Heading title"
                                              />
                                          )
                                      }
                                      sections={sections}
                                      edition={edition}
                                      key={`section-${sectionGroupTitle}`}
                                      className={styles.sectionsBlock}
                                  />
                              </div>
                          ),
                      )
                    : null}
                {!ended && awards !== null && awards.length > 0 ? (
                    <div className={styles.section}>
                        <Awards
                            title={
                                <FormattedMessage
                                    defaultMessage="Awards"
                                    description="Heading title"
                                />
                            }
                            edition={edition}
                            url={awardsUrl}
                            awards={awards}
                            isContainer={false}
                        />
                    </div>
                ) : null}
            </div>
            {blocks !== null ? <Blocks blocks={blocks} isContainer /> : null}
            <div className={styles.footer}>
                {editionsUrl !== null ? (
                    <div className={styles.buttons}>
                        <RoundedButton
                            icon={<CircledPlus />}
                            iconPosition="left"
                            href={editionsUrl}
                        >
                            <FormattedMessage
                                defaultMessage="Explore other editions"
                                description="Link label"
                            />
                        </RoundedButton>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
EditionPage.propTypes = propTypes;
EditionPage.defaultProps = defaultProps;

export default EditionPage;
